import type { SerializedDockview } from "dockview"

/**
 * Alias for the recursive grid node type used internally by Dockview's serialized layout.
 * A node is either a leaf (panel group/tab container) or a branch (split container).
 */
export type SerializedGridNode = SerializedDockview["grid"]["root"]

/**
 * Dockview serializes the grid tree with two node kinds.
 * Centralising these literals avoids duplicating them across grid-traversal utilities.
 */
export const NODE_TYPES = {
  LEAF: "leaf",
  BRANCH: "branch",
} as const
